module.exports = __webpack_public_path__ + "static/so1-d9396f88003528fab56bb4bf07379d67.gif";